<template>
	<div>
		<statistics-bafs-tourobs-filter/>
	</div>
</template>

<script>
import StatisticsBafsTourobsFilter from './StatisticsBafsTourobsFilter.vue'

export default {
	components: { StatisticsBafsTourobsFilter },
	name: 'StatisticsBafsTourobs',
	data() {
		return {

		}
	},
}

</script>
